import { useTranslation } from "react-i18next";
import NotFoundImage from "@/assets/images/errors/not-found.svg";

export default function NotFound({ goHome }: { goHome: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="bg-metal-100 font-noto-sans container mx-auto flex h-screen flex-col items-center justify-center gap-4 p-4">
      <div className="flex-center flex flex-col gap-4">
        <img src={NotFoundImage} alt="not found" width={180} height={180} className="object-contain" />

        <h2 className="text-metal-700">{t("ERROR.404.TITLE")}</h2>

        <button
          className="font-noto-sans flex-center text-primary-500 flex h-10 gap-2 rounded-lg px-4 py-2 text-base underline underline-offset-2"
          onClick={goHome}>
          {t("ERROR.404.GO_HOME")}
        </button>
      </div>
    </div>
  );
}
